/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { SurveyForceStoreService } from '@app/core/services/survey-force-store.service';
import { APP_PATH } from '@app/modules/common/enum-constant';

@Injectable({
    providedIn: 'root',
})
export class SurveyForceAccessGuard implements CanActivate {
    /**
     * Constructor
     */
    constructor(private _storeService: SurveyForceStoreService) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can activate
     *
     * @param route
     * @param state
     */
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        if (
            !state.url.includes(`/${APP_PATH.SURVEY_FORCE_QUIZ}`) &&
            this._storeService.checkIsCompleted()
        ) {
            this._storeService.navigateToErrorPage();
            return of(false);
        }
        return of(true);
    }
}
